// routes/components/OpenRoute.tsx
/**
 * OpenRoute - Routes accessible without auth (like public timer, reset password)
 */

import { ReactElement } from 'react';
import type { OpenRouteProps } from '../types';

export function OpenRoute({ children }: OpenRouteProps): ReactElement {
  return <>{children}</>;
}

export default OpenRoute;
